export const checkboxPt = (globalConfig) => ({
  ...globalConfig,
  box: ({ context, props }) => {
    const globalCheckbox = globalConfig.box({ context, props });

    return {
      class: [
        ...globalCheckbox.class,
        "!w-5 !h-5 rounded-md !border-blue-darker",
        {
          "!bg-blue-darker": context.checked,
        },
        {
          "!peer-hover:border-blue-darker": !props.disabled && !context.checked && !props.invalid,
          "!peer-hover:bg-blue-darker": !props.disabled && context.checked,
        },
      ],
    };
  },
  icon: {
    class: [...globalConfig.icon.class, "!w-3 !h-3"],
  },
});
